import MenuItem from '@mui/material/MenuItem';
import { useField } from 'formik';

import FormTextField from '../../../FormTextField';
import signUpFormLabels from '../../utils/signUpFormLabels';
import { CustomerSignUpField, OccupationOption } from '../../../../utils/forms';

const workTypeMenuItems = [
  OccupationOption.BUILDER,
  OccupationOption.CONCRETER,
  OccupationOption.LANDSCAPER,
  OccupationOption.PUMP,
  OccupationOption.OTHER,
].map((n: string) => (
  <MenuItem value={n} key={`occupation-option-${n}`}>
    {n}
  </MenuItem>
));

function OccupationField() {
  const [{ value }] = useField(CustomerSignUpField.OCCUPATION);

  return (
    <>
      <FormTextField
        id={`${CustomerSignUpField.OCCUPATION}-input`}
        fieldId={CustomerSignUpField.OCCUPATION}
        label={signUpFormLabels[CustomerSignUpField.OCCUPATION]}
        select
        inputProps={{ 'data-testid': `${CustomerSignUpField.OCCUPATION}-input` }}
      >
        {workTypeMenuItems}
      </FormTextField>

      {value === OccupationOption.OTHER && (
        <FormTextField
          id="occupation-other-input"
          fieldId={CustomerSignUpField.OCCUPATION_OTHER}
          label={signUpFormLabels[CustomerSignUpField.OCCUPATION_OTHER]}
          inputProps={{ 'data-testid': `${CustomerSignUpField.OCCUPATION_OTHER}-input` }}
        />
      )}
    </>
  );
}

export default OccupationField;
